var AdditionalImage = /** @class */ (function () {
    function AdditionalImage(obj, id) {
        if (id) {
            this.id = id;
        }
        this.image_url = obj.image_url;
    }
    ;
    Object.defineProperty(AdditionalImage.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdditionalImage.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    return AdditionalImage;
}());
export { AdditionalImage };
export function createAdditionalImage(obj, id) {
    return new AdditionalImage(obj, id);
}
export function createAdditionalImages(rawAdditionalImages) {
    var additionalImages = [];
    var rawAdditionalImagesData = rawAdditionalImages.data;
    for (var _i = 0, rawAdditionalImagesData_1 = rawAdditionalImagesData; _i < rawAdditionalImagesData_1.length; _i++) {
        var rawAdditionalImage = rawAdditionalImagesData_1[_i];
        var additionalImage = createAdditionalImage(rawAdditionalImage.attributes, rawAdditionalImage.id);
        additionalImages.push(additionalImage);
    }
    return additionalImages;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/additionalImage.ts
// module id = 251
// module chunks = 0